import { StudyArchivingConfigV1, StudyArchivingConfigV1Schema } from '@csp/config-schemas';
import { StudyArchivingConfig } from '@csp/csp-common-model/src/lib/config/StudyArchivingConfig';
import { JsonValidationService } from '@csp/csp-common-util';

const toStudyArchivingConfig = (studyArchivingConfigV1: StudyArchivingConfigV1): StudyArchivingConfig => {
  JsonValidationService.validateJsonNonStrict(
    'StudyArchivingConfigV1.json',
    StudyArchivingConfigV1Schema,
    studyArchivingConfigV1,
  );

  return {
    ...studyArchivingConfigV1,
    downloadAllFilesEnabled: studyArchivingConfigV1.downloadAllFilesEnabled ?? true,
    masterTemplateConfig: {
      ...studyArchivingConfigV1.masterTemplateConfig,
      excludedQuestionnaireCodes: studyArchivingConfigV1.masterTemplateConfig.excludedQuestionnaireCodes ?? [],
    },
  };
};

export const StudyArchivingConfigService = {
  toStudyArchivingConfig,
};
